import { v as bvVar } from 'bv';

export default () => ({
  handler: 'relativeUrl',
  data: ({ ctcType = 'standard' }) => bvVar('crackTheCode').paths[ctcType.toLowerCase()],
});
